import './radio-choice-selected.css';
import { h } from 'preact';

const { __ } = wp.i18n;

export default function RadioChoiceSelected({ name, text, onResetHandler }) {
	function onReset() {
		if (typeof onResetHandler === 'function') {
			onResetHandler(name);
		}
	}

	return (
		<p class="radio-filter-choice-selected-container filter-choice-selected-container">
			<button onClick={onReset} class="radio-filter-choice-selected-button filter-choice-selected-button">
				<svg
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
					x="0px"
					y="0px"
					width="30px"
					height="30px"
					viewBox="0 0 30 30"
					enable-background="new 0 0 30 30"
					xmlSpace="preserve"
				>
					<title>{__('close', 'real-estate-project')}</title>
					<polygon class="radio-filter-choice-selected-button-icon-shape" fill="#fff" points="30,2.8 27.2,0 15,12.2 2.8,0 0,2.8 12.2,15 0,27.2 2.8,30 15,17.8 27.2,30 30,27.2 17.8,15" />
				</svg>
				{text}
			</button>
		</p>
	);
}
